import { useMutation, useQueryClient } from "@tanstack/react-query";
import { perfilApi } from "../api/perfilApi";

// Atualizar o perfil afeta o contexto de auth (dados exibidos na navbar/saudação) e o
// checklist de onboarding (regime tributário é um dos 3 passos) — invalida os dois.
export function useUpdatePerfilMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: perfilApi.update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
      queryClient.invalidateQueries({ queryKey: ["onboarding", "status"] });
    },
  });
}
